import React from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles } from 'tss-react/mui';
import { Paper, Tabs, Tab } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isAppTypeCourtRental } from 'commons/helpers/appTypeSettings';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  tabRoot: {
    marginTop: '15px',
  },
  wrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'row',
  },
  labelContainer: {
    paddingLeft: theme.spacing(1),
  },
}));

function CustomersAndAnamnesesTab({ selectedIndex, children }) {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const isCourtRental = isAppTypeCourtRental();

  return (
    <div className={classes.root}>
      <Paper square>
        {!isCourtRental && (
          <Tabs
            value={selectedIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, newValue) => {
              if (newValue === 0) {
                navigate('/clientes');
              } else if (newValue === 1) {
                navigate('/clientes/fichas-anamneses');
              }
            }}
          >
            <Tab
              iconPosition="start"
              icon={<FontAwesomeIcon icon="users" size="lg" fixedWidth />}
              label="Clientes"
            />

            <Tab
              iconPosition="start"
              icon={<FontAwesomeIcon icon="file-signature" size="lg" fixedWidth />}
              label="Fichas Anamnese"
            />
          </Tabs>
        )}
        <div className={classes.tabRoot}>{children}</div>
      </Paper>
    </div>
  );
}

export default CustomersAndAnamnesesTab;
